import script from "./InputSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSearch.vue?vue&type=script&setup=true&lang=js"

import "./InputSearch.vue?vue&type=style&index=0&id=3f150b74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f150b74"]])

export default __exports__